module.exports = __webpack_public_path__ + "img/mpox.bc9dfea8.gif";